import type { QueueItemDetail, Role } from '@rp/contracts'
import { canReply } from '../../session/roles'
import type { ClaimStateKind } from '../item/ClaimBar'

export type ReplyAccess = { kind: 'open' } | { kind: 'claim_required' } | { kind: 'held_by_other'; holder: string }

const OPEN: ReplyAccess = { kind: 'open' }
const CLAIM_REQUIRED: ReplyAccess = { kind: 'claim_required' }

export const replyAccess = (item: QueueItemDetail, holding: ClaimStateKind): ReplyAccess => {
  if (holding === 'mine') return OPEN
  if (item.replyRequiresClaim) return CLAIM_REQUIRED
  if (holding === 'others' && item.claim !== null) return { kind: 'held_by_other', holder: item.claim.displayName }
  return OPEN
}

export const canEditDraft = (role: Role, access: ReplyAccess): boolean =>
  canReply(role) && access.kind !== 'claim_required'
